export function initFooterShopNav() {
    const items = document.querySelectorAll('.footerMain__top .nav--shop.level_1 > li.level_1');
    items.forEach(item => {
        const subNav = item.querySelector(':scope > ul.level_2');
        if (!subNav) return;

        const toggle = document.createElement('button');
        toggle.className = 'nav--shop__toggle';
        toggle.type = 'button';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.innerHTML = '<i class="icon icon-angle-down"></i>';

        item.querySelector(':scope > a').insertAdjacentElement('afterend', toggle);

        toggle.addEventListener('click', () => {
            const isOpen = item.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', String(isOpen));
        });
    });
}
